<template lang="pug">
div
  app-modal-cancelar-retificacao(
    @refresh='refresh'
    v-if="showModalRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setor'
    @closeModal="showModalRetificacao = false"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_RESPONSAVEL",
    @refresh="refresh"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro"
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :infoPrazos="showInfoVencimento() && infoPrazos",
    @updateListagem="refresh",
    :hasFiltroRapido="false",
    @atualizarFiltro="atualizarFiltro",
    :filtro="filtro",
    @changePage="changePage",
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise",
    @sort="sort",
    @executar="executar",
    @selected="false",
    @selectItem="SELECIONA_PROCESSO"
    @regerar="REGERAR_PROCESSOS"
    :showButtonRegerar="showButtonRegerar()"
  )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalContinuarAnaliseManual from '@/screens/analise/components/modal/AppModalContinuarAnaliseManual'
import AppModalRegerar from '@/screens/analise/components/modal/AppModalRegerar'
const { filtro, isGcgCgir, continuarAnaliseManual, showFiltroTipoMultiplo } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {
  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalTrocarResponsavel,
    AppModalCancelarRetificacao,
    AppModalRegerar,
    AppModalContinuarAnaliseManual
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('EM_ANALISE_UC'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      showModalRetificacao: false,
      setoresInfoVencimento: [
        'GAC',
        'GEO',
        'GCG',
        'CGIR',
        'DEAF',
        'GDA',
        'GRF',
        'GAM',
        'GEA',
        'DJ',
        'CDI',
        'GP',
        'GIT'
      ],
      processoTrocado: null,
      numeroProcesso: null,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      setor: null,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      showModalVisualizarProcesso: false,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.EM_ANALISE || [],
        filtroResponsavel: filtro?.filtroResponsavel?.EM_ANALISE || [],
        filtroMunicipio: filtro?.filtroMunicipio?.EM_ANALISE || [],
        filtroOrdemServico: filtro?.filtroOrdemServico?.EM_ANALISE || [],
        filtroFuncao: filtro?.filtroFuncao?.EM_ANALISE || [],
        filtroRua: filtro?.filtroRua?.CAIXA_ENTRADA || [],
        filtroBairro: filtro?.filtroBairro?.CAIXA_ENTRADA || [],
        filtroRemessa: filtro?.filtroRemessa?.CAIXA_ENTRADA || [],
        filtroQuadra: filtro?.filtroQuadra?.CAIXA_ENTRADA || [],
        filtroVistoriador: filtro?.filtroVistoriador?.CAIXA_ENTRADA || [],
        filtroPerfil: filtro?.filtroPerfil?.EM_ANALISE || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => this.showButtonRegerar(), ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'Número do CNUC', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome da UC', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => true },
        { id: 3, titulo: 'Esfera', propriedade: 'esfera', ordem: 4, acoes: [], exibir: () => true },
        { id: 3, titulo: 'Categoria de manejo', propriedade: 'grupoDeManejo', ordem: 4, acoes: [], exibir: () => true },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 7, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => true },
        {
          id: 11, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            {
              id: 1,
              nome: 'Visualizar Processo',
              icone: 'fa-eye',
              codigo: 'VISUALIZAR_PROCESSO',
              ordem: 1,
              show: this.showVisualizarProcesso
            },
            {
              id: 2,
              nome: 'Continuar Análise',
              icone: 'fa-edit',
              codigo: 'CONTINUAR_ANALISE',
              ordem: 1,
              show: this.showContinuarAnalise,
              showToltip: this.showToltip,
              textToltip: this.textToltip
            },
            {
              id: 3,
              nome: 'Trocar Responsável',
              icone: 'fa-user-edit',
              codigo: 'TROCAR_RESPONSAVEL',
              ordem: 1,
              show: this.showTrocarResponsavel
            }
          ]
        }
      ],
      showFiltroTipoMultiplo,
      usuario: null,
      idsProcessos: [],
      idProcessoContinuarAnaliseManual: null,
      showModalContinuarAnaliseManual: false
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      getPvtnAtivo: 'vtn/getPvtnAtivo',
      findProcessoById: 'processo/getProcessoById',
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      retornarSetor: 'processo/retornarSetor',
      exportarCsvAnalise: 'processo/exportarCsvAnalise',
      tramitarComAcao: 'processo/tramitarComAcao',
      regerar: 'filaAnaliseAutomatizada/regerar',
      retirarProcessoDaFila: 'filaAnaliseAutomatizada/retirarProcessoDaFila'
    }),

    atualizarFiltro (novoFiltro) {
      this.filtro = {
        ...this.filtro,
        ...novoFiltro
      }
      this.filtroRapido = novoFiltro
    },

    showButtonRegerar () {
      return isGcgCgir && isGcgCgir(this.usuario?.perfilSelecionado?.setor?.codigo)
    },

    showColuna (coluna) {
      return (
        this.configuracaoFiltro[coluna].find(
          perfil => perfil === this.usuario?.perfilSelecionado?.codigo
        ) !== undefined
      )
    },
    showInfoVencimento () {
      return this.setoresInfoVencimento.find(
        setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo
      )
    },
    CONTINUAR_CALCULAR_VTN_MA: async (_this, { item }) => {
      _this.$router.push({
        name: 'calcular-vtn-ma',
        params: {
          idProcesso: item.id,
          protocolo: item.numeroProtocolo
        }
      })
    },
    CONTINUAR_ANALISE: (_this, { item }) => {
      _this.idProcessoContinuarAnaliseManual = item.id
      _this.showModalContinuarAnaliseManual = continuarAnaliseManual(_this, item)
    },
    CONTINUAR_EMISSAO_EXTRATO_SENTENCA: (_this, { item }) => {
      _this.$router.push({
        name: 'continuar-emissao-extrato-sentenca',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    CONTINUAR_RETIFICACAO_TITULO: async (_this, { item }) => {
      _this.$router.push({
        name: 'continuar-emissao-titulo',
        params: {
          idProcesso: item.id,
          tipo: 'RETIFICAR_TITULO',
          urlOrigem: 'EM_ANALISE'
        }
      })
    },

    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()

      this.exportarCsvAnalise(this.filtro)
    },

    TROCAR_RESPONSAVEL: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },

    async CONTINUAR_CONFERENCIA_TITULO (_this, { item }) {
      this.$router.push({
        name: 'conferencia-titulo-certidao',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          numeroProcesso: item.numeroProcesso
        }
      })
    },
    SELECIONA_PROCESSO (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        this.idsProcessos.push(item.id)
      } else {
        this.idsProcessos.splice(this.idsProcessos.indexOf(item.id), 1)
      }
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    async CONTINUAR_EMISSAO (_this, { item }) {
      if (item.numeroTituloCertidao && item.tipoCodigo === 'CERTIDAO_TITULO') {
        this.$router.push({
          name: 'LISTAGEM_CERTIDAO',
          query: { tipo: 'TITULO_CERTIDAO' },
          params: {
            idProcesso: item.id,
            urlOrigem: 'EM_ANALISE'
          }
        })
      } else {
        this.$router.push({
          name: 'continuar-emissao-titulo',
          params: {
            idProcesso: item.id,
            tipo: 'EMITIR_TITULO',
            urlOrigem: 'EM_ANALISE'
          }
        })
      }
    },

    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },

    CANCELAR_RETIFICACAO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
      this.setor = item.setor
      this.showModalRetificacao = true
    },

    async CONTINUAR_EMISSAO_OFICIO (_this, { item }) {
      this.$router.push({
        name: 'oficio',
        query: {
          idProcesso: item.id
        },
        params: {
          isEdicao: true
        }
      })
    },
    CONTINUAR_CALCULAR_VTN_RR: async (_this, { item }) => {
      _this.$router.push({
        name: 'calcular-vtn-rr',
        params: {
          processo: item,
          acaoCaixa: 'EM_ANALISE'
        }
      })
    },
    CONTINUAR_CALCULAR_VTN_AP: async (_this, { item }) => {
      await _this.getPvtnAtivo(1600105)
      _this.$router.push({
        name: 'calcular-vtn-ap',
        params: {
          processo: item,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    RETORNAR_SETOR (_this, { item }) {
      this.retornarSetor({idProcesso: item.id})
        .then(() => {
          _this.refresh()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Processo retornado ao setor anterior')
        }).catch(({ message }) => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            message)
        })
    },
    async CONTINUAR_EMISSAO_CERTIDAO_AREA (_this, { item }) {
      _this.$router.push({
        name: 'CONTINUAR_EMISSAO_CERTIDAO_AREA',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'EM_EMISSAO_CERTIDAO_AREA'
        }
      })
    },
    REGERAR_PROCESSOS () {
      if (this.idsProcessos.length > 0) {
        this.confirmBox(this.$messages.AVISO_REGERAR, this.$messages.TITULO_WARNING,
          async () => {
            await this.regerar(this.idsProcessos)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo(s) enviados para a Fila')
            location.reload()
          },
          () => { }
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/EmAnaliseListagemUc.vue